module.exports = __webpack_public_path__ + "img/referencia5.79b0efff.png";